import { Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/data';

export default function FeaturedArticles() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 4);

  return (
    <section className="py-16 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              精选推荐
            </h2>
            <p className="text-foreground-600 text-sm">编辑团队精心挑选的优质内容</p>
          </div>
          <Link
            to="/category/zone1"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredArticles.map((article, index) => {
            const cat = categories.find((c) => c.slug === article.category);
            const isLarge = index === 0;
            return (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className={`group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden transition-all duration-300 hover:scale-[1.02] ${
                  isLarge ? 'md:col-span-2 md:row-span-2' : ''
                }`}
              >
                <div className={`relative overflow-hidden ${isLarge ? 'h-52' : 'h-40'}`}>
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    title={`${article.title} - 亚洲精品一区二区`}
                  />
                  <div className="absolute top-3 left-3">
                    <span
                      className={`px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
                        article.category === 'zone1'
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-accent-500 text-background-50'
                      }`}
                    >
                      {cat?.name}
                    </span>
                  </div>
                </div>

                <div className="p-5">
                  <h3
                    className={`font-heading font-semibold text-foreground-900 leading-snug mb-3 group-hover:text-primary-600 transition-colors ${
                      isLarge ? 'text-lg' : 'text-sm'
                    }`}
                  >
                    {article.title}
                  </h3>
                  <p className={`text-foreground-600 leading-relaxed mb-4 ${isLarge ? 'text-sm line-clamp-3' : 'text-xs line-clamp-2'}`}>
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-foreground-500">
                    <span>{article.publishDate}</span>
                    <span>{article.readTime} 分钟阅读</span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/zone1"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            查看全部精选
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}